import React from 'react';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function Pagination({ page, totalPages, setPage }) {
    const nextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    }

    const prevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    }

    return (
        <div className="flex justify-center items-center my-4 mt-10">
            <button onClick={prevPage} className="mx-2 p-2 bg-blue-900 text-white rounded-lg"><FaArrowLeft/></button>
            <p>{page} sur {totalPages}</p>
            <button onClick={nextPage} className="mx-2 p-2 bg-blue-900 text-white rounded-lg"><FaArrowRight/></button>
        </div>
    );
}

export default Pagination;